import cn from 'classnames'
import { forwardRef, memo, ReactNode } from 'react'
import {
  Collapse as CollapseComponent,
  CollapseProps as CollapseComponentProps,
  UnmountClosed as UnmountCollapseComponent,
} from 'react-collapse'

import styles from './Collapse.module.scss'

export interface CollapseProps extends Pick<CollapseComponentProps, 'onWork' | 'onRest' | 'initialStyle'> {
  children: ReactNode
  opened?: boolean
  scale?: boolean
  opacity?: boolean
  unmount?: boolean
  outerClassName?: string
  innerClassName?: string
}

const Collapse = forwardRef<CollapseComponent, CollapseProps>(
  ({ children, opened, scale, opacity = true, unmount, innerClassName, outerClassName, ...props }, ref) => {
    const theme = {
      collapse: cn(
        styles.root,
        { [styles.scale]: scale, [styles.opacity]: opacity, [styles.opened]: opened },
        outerClassName
      ),
      content: innerClassName,
    } as CollapseComponentProps['theme']

    const Element = unmount ? UnmountCollapseComponent : CollapseComponent

    return (
      <Element ref={ref} isOpened={opened} theme={theme} {...props}>
        {children}
      </Element>
    )
  }
)

export default memo(Collapse) as typeof Collapse
